<template>
  <v-card outlined class="my-3">
  <v-card-text>
    <v-row dense>
      <!-- Red 1: Naziv + Cene (u istom redu) -->
      <v-col cols="12" md="6">
        <text-field
          v-if="language === 'default'"
          v-model="editedItem.name"
          :label="$t('title')"
          required
          :rules="[rules.required]"
          outlined
          hide-details
          dense
        />
        <text-field
          v-else
          v-model="editedItem.translations.find((t) => t.code === language).name"
          :label="$t('title')"
          outlined
          hide-details
          dense
        />
      </v-col>

      <v-col cols="6" md="2">
        <text-field
          v-model="editedItem.code"
          :label="$t('item_code')"
          outlined
          dense
          hide-details
        />
      </v-col>

      <v-col cols="6" md="2">
        <text-field
          type="number"
          v-model="editedItem.price"
          :label="$t('basic_price')"
          hide-details
          :suffix="currency"
          outlined
          dense
        />
      </v-col>

      <v-col cols="6" md="2">
        <text-field
          type="number"
          v-model="editedItem.last_price"
          label="Stara cena"
          hide-details
          :suffix="currency"
          outlined
          dense
        />
      </v-col>

      <!-- Red 2: Kategorija i Note -->
      <v-col cols="12" md="6">
        <autocomplete
          v-model="editedItem.category"
          :items="categories"
          dense
          hide-details
          :label="$t('group_meal')"
          return-object
          item-text="name"
          item-value="id"
          required
          :rules="[rules.required]"
          outlined
          :disabled="readOnlyCategory"
        />
      </v-col>
      <v-col cols="12" md="6">
        <text-field
          v-model="editedItem.note"
          :label="$t('note')"
          outlined
          hide-details
          dense
        />
      </v-col>

      <!-- Red 3: Opis -->
      <v-col cols="12">
        <text-area
          v-if="language === 'default'"
          rows="2"
          v-model="editedItem.description"
          :label="$t('description')"
          outlined
          hide-details
          dense
          auto-grow
        />
        <text-area
          v-else
          rows="2"
          v-model="editedItem.translations.find((t) => t.code === language).description"
          :label="$t('description')"
          outlined
          hide-details
          dense
          auto-grow
        />
      </v-col>
    </v-row>
  </v-card-text>
</v-card>
</template>

<script>
import hasValidation from "@/mixins/hasValidation";

export default {
  name: "FoodBasicInfo",
  mixins: [hasValidation],
  props: {
    editedItem: {
      type: Object,
      required: true,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    currency: {
      type: String,
      default: "",
    },
    readOnlyCategory: {
      type: Boolean,
      default: false,
    },
    language: {
      type: String,
      default: "default",
    },
  },
};
</script>
